import React from 'react';
import PropTypes from 'prop-types';
import usePINInput from './hooks/usePINInput';
import ColorSF2 from '../../styles/common/ColorSF2';

/**
 * PINコード入力コンポーネント
 * @param {number} length - PINコードの桁数
 * @param {function} onComplete - PINコードが入力された際に呼び出されるコールバック関数
 * @param {boolean} isError - エラーが発生しているかどうか
 */
const PINInput = ({ length, onComplete, isError }) => {
  const { inputs, handleChange, handleKeyDown, handleFocus, inputRefs } =
    usePINInput(length, onComplete);

  // 入力済みのフィールドのスタイル
  const getInputStyle = value => {
    let borderColor;
    if (isError) {
      borderColor = ColorSF2.red;
    } else if (value) {
      borderColor = ColorSF2.navyBlue;
    } else {
      borderColor = ColorSF2.silverGray;
    }

    return {
      width: '50px',
      height: '50px',
      textAlign: 'center',
      margin: '5px',
      fontSize: '20px',
      fontWeight: 'bold',
      border: `1px solid ${borderColor}`,
      borderRadius: '4px',
    };
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      {inputs.map((input, index) => (
        <input
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          // eslint-disable-next-line no-return-assign
          ref={el => (inputRefs.current[index] = el)}
          type="tel"
          maxLength="1"
          value={inputs[index]}
          onChange={e => handleChange(index, e.target.value)}
          onKeyDown={e => handleKeyDown(e, index)}
          onFocus={handleFocus}
          style={getInputStyle(input)}
          inputMode="numeric"
        />
      ))}
    </div>
  );
};

PINInput.propTypes = {
  length: PropTypes.number.isRequired,
  onComplete: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
};

export default PINInput;
